import { useApplyBodyStyle, useProductVersion } from '@/hooks';
import Link from '@/storybook/components/Link/Link';
import Text from '@/storybook/components/Text/Text';
import { AppRoutes } from '@/utils';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';
import styles from './Footer.module.css';

enum FooterDataTestIds {
  Copyright = 'footer-copyright',
  Disclaimer = 'footer-disclaimer',
}

const learnMore = 'https://go.roche.com/ces_gsite';
const roadmap = 'https://docs.google.com/presentation/d/1MrkD8iTMLsoXc7ZoqoxW-vYA6rf9Ixz3DayOdHZchQ0/edit';

const Footer = () => {
  const { t } = useTranslation('translation', { keyPrefix: 'footer' });
  const version = useProductVersion();
  useApplyBodyStyle({ paddingBottom: 'var(--footer-height)' });

  const year = dayjs().year();

  return (
    <footer>
      <div className={styles.footer}>
        <div className={styles.top}>
          <Text data-testid={FooterDataTestIds.Copyright} className={styles.title}>
            {t('copyright', { year, version })}
          </Text>
          <div className={styles.links}>
            <Link to={learnMore} appearance="secondary" size="S" isExternal>
              {t('links.learnMoreCES')}
            </Link>
            <Link to={AppRoutes.DISCLAIMER_PAGE} appearance="secondary" size="S">
              {t('links.disclaimer')}
            </Link>
            <Link isExternal to={roadmap} appearance="secondary" size="S">
              {t('links.seeRoadmap')}
            </Link>
            <Link to={AppRoutes.DATA_REFRESH_DETAILS} appearance="secondary" size="S">
              {t('links.dataRefreshDetails')}
            </Link>
          </div>
        </div>
        <Text data-testid={FooterDataTestIds.Disclaimer} className={styles.disclaimer}>
          {t('disclaimer')}
        </Text>
      </div>
    </footer>
  );
};

export default Footer;
